import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const receptyService = {
    createPakietRecept,
    getPakiety,
    sprawdzPakiet,
    createPakiet,
    pobierzPdf,
    getPakietRecept,
    updatePakietRecept,
    anulujRecepte,
    wyslijSmsPakietu
};
function createPakietRecept(data)
{
    return axios.post('/api/services/app/Recepty/CreatePakietRecept',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getPakiety(data)
{
    return axios.get('/api/services/app/Recepty/GetPakiety', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function sprawdzPakiet(pakietId, haslo)
{
    return axios.post('/api/services/app/Recepty/SprawdzPakiet',{pakiet_id: pakietId, haslo_certyfikatu: haslo}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function createPakiet(pakietId, haslo)
{
    return axios.post('/api/services/app/Recepty/StworzPakietRecept',{pakiet_id: pakietId, haslo_certyfikatu: haslo}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function pobierzPdf(pakietId,haslo)
{
    return axios.post('/api/services/app/Recepty/GenerujReceptaHtml', {pakietId: pakietId, haslo_certyfikatu: haslo},{
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function getPakietRecept(pakietid)
{
    return axios.get('/api/services/app/Recepty/GetPakietRecept', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {pakietid: pakietid}
    })
}

function updatePakietRecept(data)
{
    return axios.put('/api/services/app/Recepty/UpdatePakietRecept',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function anulujRecepte(id, pakietid,haslo)
{
    return axios.post('/api/services/app/Recepty/AnulujRecepte',{pakietId: pakietid, receptaid: id, haslo_certyfikatu: haslo}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function wyslijSmsPakietu(id)
{
    return axios.post('/api/services/app/Recepty/WyslijSmsPakietu',null, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {pakietid: id}
    })
}